import React from 'react'
import { Stack, Box, Text } from '@chakra-ui/react'
interface ModalDescriptionDetailsProps {
  sourceAccountDescription: string | undefined
  sourceAccountDescription2: string | undefined
  destinationAccountDescription: string | undefined
  destinationAccountDescription2: string | undefined
}

export const ModalDescriptionDetails = ({
  sourceAccountDescription,
  sourceAccountDescription2,
  destinationAccountDescription,
  destinationAccountDescription2
}: ModalDescriptionDetailsProps) => {
  return (
    <Stack spacing={6}>
      {(sourceAccountDescription || sourceAccountDescription2) && (
        <Stack direction='row' w='100%' spacing={4}>
          {sourceAccountDescription && (
            <Box w='50%' data-testid='sourceAccountDescriptionOne'>
              <Text fontWeight='bold'>Source Account Description</Text>
              <Text className='test-id-source-account-description-one'>{sourceAccountDescription}</Text>
            </Box>
          )}
          {sourceAccountDescription2 && (
            <Box w='50%' data-testid='sourceAccountDescriptionTwo'>
              <Text fontWeight='bold'>Source Account Description 2</Text>
              <Text className='test-id-source-account-description-two'>{sourceAccountDescription2}</Text>
            </Box>
          )}
        </Stack>
      )}
      {(destinationAccountDescription || destinationAccountDescription2) && (
        <Stack direction='row' w='100%' spacing={4}>
          {destinationAccountDescription && (
            <Box w='50%' data-testid='destinationAccountDescriptionOne'>
              <Text fontWeight='bold'>Destination Account Description</Text>
              <Text className='test-id-destination-account-description-one'>{destinationAccountDescription}</Text>
            </Box>
          )}
          {destinationAccountDescription2 && (
            <Box w='50%' data-testid='destinationAccountDescriptionTwo'>
              <Text fontWeight='bold'>Destination Account Description 2</Text>
              <Text className='test-id-destination-account-description-two'>{destinationAccountDescription2}</Text>
            </Box>
          )}
        </Stack>
      )}
    </Stack>
  )
}
